import { useState } from 'react';

export function useFilterBar(filterRef) {
  const [activeFilter, setActiveFilter] = useState(0);
  const [filterHoverStyle, setFilterHoverStyle] = useState({
    transform: 'translateX(0px)',
    width: '0px',
    opacity: 0
  });

  const handleFilterClick = (index) => {
    setActiveFilter(index);
    if (filterRef.current) {
      const filterItems = filterRef.current.children;
      const activeItem = filterItems[index + 1]; // +1 to skip indicator div
      if (activeItem) {
        setFilterHoverStyle({
          transform: `translateX(${activeItem.offsetLeft}px)`,
          width: `${activeItem.offsetWidth}px`,
          opacity: 1
        });
      }
    }
  };

  return {
    activeFilter,
    filterHoverStyle,
    handleFilterClick
  };
}
